const _ = require('lodash');
const segmentUtil = {};

segmentUtil.parseFeeObj = function (feeObj) {
  const keyArray = [
    'guest_payment_processing_fee_percent',
    'guest_payment_processing_fee',
    'host_warnings',
    'guest_payment_amount',
    'subtotal_amount',
    'guest_id',
    'host_id',
    'duration',
    'discounts'
  ];
  // Values picked from listing obj
  const editedFeeObj = _.pick(feeObj, keyArray);
  const filteredDiscounts = editedFeeObj.discounts.filter((o) => { return 'DAY_RATE_DISCOUNT' === o.type; });
  const hasDayRate = filteredDiscounts.length > 0;
  editedFeeObj.day_rate_discount_amount = hasDayRate ? filteredDiscounts[0].discount_amount : '';
  editedFeeObj.display_date = feeObj.start.display.date;
  editedFeeObj.display_start = feeObj.start.display.time;
  editedFeeObj.display_end = feeObj.end.display.time;
  return editedFeeObj;
};

segmentUtil.segmentListingObj = function (listing) {
  const hasCleaningFee = 'ACTIVATED' === _.get(listing, 'cleaning_fee.obj_state');
  const hasDayRate = 'ACTIVATED'  === _.get(listing, 'day_rate_discount.obj_state');
  const responsivenessObj = _.get(listing, 'host_responsiveness');
  const segmentListingObj = {
    listing_id: listing._id,
    metro: listing.metro,
    neighborhood: listing.neighborhood,
    city: listing.city,
    state: listing.state,
    zip: listing.zip,
    country: listing.country,
    use_type: listing.use_type,
    total_reviews: listing.space_review_count,
    space_review_count: listing.space_review_count,
    space_review_stars: listing.space_review_stars,
    title: listing.page_title,
    cover_img_url: listing.cover_img,
    currency_type: listing.currency,
    currency_symbol: listing.currency_symbol,
    ownerAvatarUrl: listing.ownerAvatarUrl,
    ownerId: listing.ownerId,
    ownerFirstName: listing.ownerFirstName,
    ownerLastName: listing.ownerLastName,
    price_hourly: listing.price,
    cleaning_fee_set: hasCleaningFee,
    cleaning_fee_amount: hasCleaningFee ? listing.cleaning_fee.value : 0,
    day_rate_discount_set: hasDayRate,
    day_rate_discount_percent: hasDayRate ? listing.day_rate_discount.value : 0,
    next_page: listing.listing_reviews ? listing.listing_reviews.length : null
  };
  if (!_.isEmpty(responsivenessObj)) {
    segmentListingObj.host_response_time = responsivenessObj.hours;
    segmentListingObj.host_response_bucket = responsivenessObj.bucket;
    segmentListingObj.host_response_status = responsivenessObj.level_label;
  }
  return segmentListingObj;
};

module.exports = segmentUtil;
